import React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { Drawer } from '@material-ui/core';
import { AppListingFragment } from '../../types/generated';
import { AppDetailsView } from '../../pages/AppStore/AppDetails/AppDetailsView';

export const ListingPreviewer: React.FC<{
    listing: AppListingFragment;
    previewDialogOpen: boolean;
    setPreviewDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ listing, previewDialogOpen, setPreviewDialogOpen }) => {
    const [previewWidth, setPreviewWidth] = React.useState<string | null>('medium');

    return (
        <Drawer
            anchor={'right'}
            open={previewDialogOpen}
            onClose={() => setPreviewDialogOpen(false)}
        >
            <div
                style={{
                    width:
                        previewWidth === 'large'
                            ? window.innerWidth * 0.8
                            : previewWidth === 'medium'
                            ? window.innerWidth * 0.5
                            : '400px',
                }}
            >
                <div>
                    <ToggleButtonGroup
                        value={previewWidth}
                        exclusive
                        onChange={(va, next) => {
                            setPreviewWidth(next);
                        }}
                        aria-label="text formatting"
                    >
                        <ToggleButton value="small" aria-label="small">
                            Small
                        </ToggleButton>
                        <ToggleButton value="medium" aria-label="medium">
                            Medium
                        </ToggleButton>
                        <ToggleButton value="large" aria-label="large">
                            Large
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                {/* @ts-ignore */}
                <AppDetailsView listing={listing} />
            </div>
        </Drawer>
    );
};
